import { RefreshCw, AlertTriangle } from "lucide-react";

export default function SuggestionsRefreshNotice({ onRefresh, refreshing = false }) {
    return (
        <div className="srn-shell">
            <div className="srn-copy">
                <div className="srn-badge">
                    <AlertTriangle size={14} />
                    <span>Suggestions Outdated</span>
                </div>

                <h3 className="srn-title">Your AI suggestions may need a refresh</h3>

                <p className="srn-subtitle">
                    You changed core business details after AI generated strategy suggestions.
                    Refresh to realign pages, structure, tone, and layout with the updated inputs.
                </p>
            </div>

            <button
                type="button"
                className="wg-primary-btn"
                onClick={onRefresh}
                disabled={refreshing}
            >
                {refreshing ? "Refreshing..." : "Refresh Suggestions"}
                {!refreshing && <RefreshCw size={16} />}
            </button>
        </div>
    );
}